import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {FileManagerTabsComponent} from './file-manager-tabs/file-manager-tabs.component';

const routes: Routes = [
  {
    path: 'document/:id',
    component: FileManagerTabsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FileManagerRoutingModule {}
